import {Injectable, inject} from '@angular/core';
import mixpanel from 'mixpanel-browser';
import {User} from '../user';
import {HttpClient} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import {OctDocumentService} from '@services/document';
import {USER_REGION_KEY, WORKFLOW_USER_KEY} from '@shared/constants/storage-keys';
import {BrowserStorageService} from '@core/services';

export const MIXPANEL_TOKEN = '603feb3175de7fbe5c2ef4cca341f1bf';
export const MIXPANEL_USER_ACTION_KEY_VALUES = (user: User, userRegion = '', tenant = '') => ({
  'User Name': user?.attributes?.name ?? '',
  'User Email': user?.attributes?.email ?? '',
  'User Region': userRegion,
  'Tenant Name': tenant
});

@Injectable({
  providedIn: 'root'
})
export class MixpanelService {
  private readonly _http = inject(HttpClient);
  private readonly _docService = inject(OctDocumentService);
  protected _localStorageService = inject(BrowserStorageService);

  tenantName = this._docService.activeCompanyPrefix();

  getUserRegion() {
    if (this._localStorageService.get(USER_REGION_KEY)) {
      return EMPTY;
    }
    return this._http
      .get<{
        country_code: string;
      }>('https://geolocation-db.com/json/0f761a30-fe14-11e9-b59f-e53803842572')
      .pipe(
        catchError(() => of({country_code: 'UK'})),
        map(data => {
          this._localStorageService.set(USER_REGION_KEY, data.country_code);
          return data.country_code;
        })
      );
  }

  userData() {
    return MIXPANEL_USER_ACTION_KEY_VALUES(
      JSON.parse(this._localStorageService.get(WORKFLOW_USER_KEY) || '{}'),
      this._localStorageService.get(USER_REGION_KEY) || '',
      this.tenantName
    );
  }

  init() {
    mixpanel?.init(MIXPANEL_TOKEN);
  }

  track<T>(key: string, action: T) {
    mixpanel?.track(key, action);
  }
}
